import { Card, Stack, Text } from '@tiendanube/components';
import { SendWhatsAppLink } from 'commons/components';
import { emptyIsNullInText } from 'commons/utils';
import { convertNullToEmptyText } from 'commons/utils/convertNullToEmptyText';
import { useStoreName } from 'domains/Auth/hooks';
import useTranslationOrders from 'domains/Orders/useTranslationOrders/useTranslationOrders';

export interface DeliveryInfoCardInterface {
  receiverName: string;
  receiverPhone: string;
  zipcode: string;
  street: string | null;
  number: string | null;
  floor: string | null;
  city: string | null;
  province: string | null;
  country: string;
}

interface DeliveryInfoCardProps {
  deliveryData: DeliveryInfoCardInterface;
  url?: string;
  signature?: string;
}

function DeliveryInfoCard({
  deliveryData,
  url,
  signature,
}: DeliveryInfoCardProps) {
  const t = useTranslationOrders();
  const nameStore = useStoreName();

  const getSecondAddressLine = () => {
    const items = [deliveryData.city, deliveryData.province].filter(
      (item) => item,
    );
    items.push(deliveryData.country);
    return items.join(', ');
  };
  return (
    <Card title={t('abandonedCarts.deliveryInfoCard.title')}>
      <Stack
        column
        align="flex-start"
        spacing={deliveryData.receiverName ? 'tight' : 'none'}
      >
        {!!deliveryData.receiverName && (
          <Stack.Item>
            <Text block>{deliveryData.receiverName}</Text>
            {!!deliveryData.receiverPhone && (
              <SendWhatsAppLink
                phoneNumber={deliveryData.receiverPhone}
                textChild={deliveryData.receiverPhone}
                textWhatsapp={t('abandonedCarts.sendEmail.body', {
                  nameClient: deliveryData.receiverName,
                  nameStore,
                  interpolation: { escapeValue: false },
                })}
                url={url}
                signature={signature}
              />
            )}
          </Stack.Item>
        )}
        <Stack.Item>
          <Text size="caption" appearance="light" block>
            {`${t('abandonedCarts.deliveryInfoCard.address')}`}
          </Text>
          <Text block>
            {`
              ${convertNullToEmptyText(deliveryData.street)}
              ${emptyIsNullInText(convertNullToEmptyText(deliveryData.number))}
              ${convertNullToEmptyText(deliveryData.floor)}
              (${deliveryData.zipcode})`}
          </Text>
          <Text block>{getSecondAddressLine()}</Text>
        </Stack.Item>
      </Stack>
    </Card>
  );
}

export default DeliveryInfoCard;
